module.exports = __webpack_public_path__ + "img/receipt_button.f001608f.png";